if (!customElements.get('m-countdown-timer')) {
  class MCountdownTimer extends HTMLElement {
    constructor() {
      super();

      this.timerInterval = null;
      this.repeatDaily = false;
      this.utcOffsetMinutes = 330;
      this.staticEndTime = null;

      this.dayElement = null;
      this.hourElement = null;
      this.minuteElement = null;
      this.secondElement = null;
    }

    connectedCallback() {
      this.dayElement = this.querySelector('.countdown-timer-day');
      this.hourElement = this.querySelector('.countdown-timer-hour');
      this.minuteElement = this.querySelector('.countdown-timer-minute');
      this.secondElement = this.querySelector('.countdown-timer-sec');

      this.repeatDaily = this.dataset.repeatDaily === 'true';

      const parsedOffset = Number.parseInt(
        this.dataset.utcOffset || '330',
        10
      );

      this.utcOffsetMinutes = Number.isNaN(parsedOffset)
        ? 330
        : parsedOffset;

      if (this.repeatDaily) {
        this.startDailyCountdown();
      } else {
        this.startStaticCountdown();
      }
    }

    disconnectedCallback() {
      this.stopTimer();
    }

    startDailyCountdown() {
      this.stopTimer();

      this.showTimer();
      this.updateDailyCountdown();

      this.timerInterval = window.setInterval(() => {
        this.updateDailyCountdown();
      }, 1000);
    }

    updateDailyCountdown() {
      const currentTime = Date.now();
      const nextMidnight = this.getNextMidnightTimestamp(currentTime);

      let remainingMilliseconds = Math.max(
        0,
        nextMidnight - currentTime
      );

      let totalSeconds = Math.floor(
        remainingMilliseconds / 1000
      );

      /*
       * Exactly at midnight the next target is 24 hours away.
       * This prevents the timer from briefly showing:
       * 01 Days 00 Hours 00 Minutes 00 Seconds
       */
      if (totalSeconds >= 86400) {
        totalSeconds = 86399;
      }

      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor(
        (totalSeconds % 3600) / 60
      );
      const seconds = totalSeconds % 60;

      this.updateTimerDisplay(0, hours, minutes, seconds);
    }

    getNextMidnightTimestamp(currentTimestamp) {
      const offsetMilliseconds =
        this.utcOffsetMinutes * 60 * 1000;

      /*
       * Shift the current UTC time into the selected timezone.
       * IST uses an offset of 330 minutes.
       */
      const shiftedDate = new Date(
        currentTimestamp + offsetMilliseconds
      );

      /*
       * Create next day's 00:00:00 in the shifted timezone.
       */
      const nextMidnightInShiftedTime = Date.UTC(
        shiftedDate.getUTCFullYear(),
        shiftedDate.getUTCMonth(),
        shiftedDate.getUTCDate() + 1,
        0,
        0,
        0,
        0
      );

      /*
       * Convert the shifted midnight back to real UTC timestamp.
       */
      return nextMidnightInShiftedTime - offsetMilliseconds;
    }

    startStaticCountdown() {
      const time = this.dataset.time;

      if (!time) {
        this.hideTimer();
        return;
      }

      const formattedTime = time.trim().replace(' ', 'T');
      const parsedEndTime = Date.parse(formattedTime);

      if (Number.isNaN(parsedEndTime)) {
        console.warn(
          'Countdown timer: Invalid end time:',
          time
        );

        this.hideTimer();
        return;
      }

      this.staticEndTime = parsedEndTime;

      this.stopTimer();
      this.updateStaticCountdown();

      this.timerInterval = window.setInterval(() => {
        this.updateStaticCountdown();
      }, 1000);
    }

    updateStaticCountdown() {
      const remainingMilliseconds =
        this.staticEndTime - Date.now();

      if (remainingMilliseconds <= 0) {
        this.updateTimerDisplay(0, 0, 0, 0);
        this.stopTimer();
        this.hideTimer();
        return;
      }

      const totalSeconds = Math.floor(
        remainingMilliseconds / 1000
      );

      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor(
        (totalSeconds % 86400) / 3600
      );
      const minutes = Math.floor(
        (totalSeconds % 3600) / 60
      );
      const seconds = totalSeconds % 60;

      this.updateTimerDisplay(
        days,
        hours,
        minutes,
        seconds
      );

      this.showTimer();
    }

    updateTimerDisplay(days, hours, minutes, seconds) {
      if (this.dayElement) {
        this.dayElement.textContent =
          this.formatNumber(days);
      }

      if (this.hourElement) {
        this.hourElement.textContent =
          this.formatNumber(hours);
      }

      if (this.minuteElement) {
        this.minuteElement.textContent =
          this.formatNumber(minutes);
      }

      if (this.secondElement) {
        this.secondElement.textContent =
          this.formatNumber(seconds);
      }
    }

    formatNumber(number) {
      return String(number).padStart(2, '0');
    }

    showTimer() {
      this.classList.remove('hidden');
      this.classList.remove('m:hidden');
      this.style.opacity = '1';
      this.style.visibility = 'visible';
    }

    hideTimer() {
      this.style.opacity = '0';
      this.style.visibility = 'hidden';
    }

    stopTimer() {
      if (this.timerInterval) {
        window.clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    }
  }

  customElements.define(
    'm-countdown-timer',
    MCountdownTimer
  );
}